import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatSize',
    standalone: true
})
export class FormatSizePipe implements PipeTransform {
  ext = [' Ko', ' Mo', ' Go'];
  i = 0;

  transform(value: number): string {
    const val = this.formatValue(value);
    return `${val}${this.ext[this.i]}`;
  }

  private formatValue(size: number) {
    const sizeTemp = size / 1024;

    if(sizeTemp > 1000) {
      this.i++;
      return this.formatValue(sizeTemp);
    }

    return sizeTemp.toFixed(1);
  }

}
